export default "__VITE_ASSET__Dl2yQZHX__"